import React from 'react';
import './Soporte.css';

const Soporte = ({ onBack }) => {
    

    return (
        <div className="public-page">
            <button className="btn-secondary" onClick={onBack}>
                Volver
            </button>
            <header className="public-page-header">
                <h2>Centro de Soporte</h2>
                <p>Estamos aquí para ayudarte. Contacta con nuestro equipo de soporte.</p>
            </header>

            <section className="public-page-content">
                
                <h3>Formas de contactarnos</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '30px' }}>
                    <div style={{ padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                        <h4>📧 Correo electrónico</h4>
                        <p>
                            <strong>lotea.app@gmail.com</strong>
                            {/* <strong>soporte@lotea.app</strong> */}
                        </p>
                        <p>Para consultas generales, reportes de errores y solicitudes de asistencia.</p>
                    </div>
                    <div style={{ padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
                        <h4>⏱️ Tiempos de respuesta</h4>
                        <ul style={{ margin: '10px 0', paddingLeft: '20px' }}>
                            <li>Consultas generales: 24-48 horas hábiles</li>
                            <li>Problemas críticos: 2-4 horas hábiles</li>
                            <li>Reportes de seguridad: máxima prioridad</li>
                        </ul>
                    </div>
                </div>

                <h3>Antes de contactar, considera:</h3>
                <ul>
                    <li>Revisa las <strong>Preguntas Frecuentes</strong> - tu pregunta podría estar respondida</li>
                    <li>Limpia el caché del navegador (Ctrl+F5 o Cmd+Shift+R)</li>
                    <li>Intenta acceder desde otro navegador</li>
                    <li>Verifica que tengas los permisos correctos en tu cuenta</li>
                </ul>

                <h3>Información que incluir en tu reporte</h3>
                <p>Para ayudarte de forma más rápida, incluye:</p>
                <ul>
                    <li>Descripción clara y detallada del problema</li>
                    <li>Pasos específicos para reproducir el error</li>
                    <li>Navegador y sistema operativo que usas</li>
                    <li>Capturas de pantalla o vídeos del problema (si aplica)</li>
                    <li>Identificador del proyecto o lote afectado (si aplica)</li>
                    <li>Horario aproximado en que ocurrió el problema</li>
                </ul>

                <h3>Horario de atención</h3>
                <p>
                    Nuestro equipo de soporte atiende de <strong>lunes a viernes, 09:00 - 18:00 (hora local)</strong>.
                    Los mensajes enviados fuera de horario serán respondidos en la primera hora hábil siguiente.
                </p>

                <h3>Reportar un problema de seguridad</h3>
                <p>
                    Si descubres una vulnerabilidad de seguridad, <strong>no lo publiques públicamente</strong>. 
                    En su lugar, contacta directamente a <strong>lotea.app@gmail.com</strong> con los detalles del problema. 
                    Tomaremos acción inmediata.
                </p>
 {/* <strong>seguridad@lotea.app</strong> */}
                <h3>Acceso desde tu cuenta</h3>
                <p>
                    También puedes enviar mensajes de soporte directamente desde tu Dashboard en LOTEA. 
                    Esto permite un mejor seguimiento de tu caso.
                </p>

            </section>
        </div>
    );
};

export default Soporte;